import { alwaysRefetchApiQueryOptions } from 'BreetHelpers';
import { useFiatWithdrawRequestContext, useUsdWithdrawRequestContext, useWithdrawRequestContext } from 'BreetHooks';
import { useGetFeatureNoteQuery } from 'BreetRedux';

import { NotificationBanner } from '../NotificationBanner';
import { SelectWallet } from '../SelectWallet';

const Header = () => {
	const { selectedWallet, selectWallet } = useWithdrawRequestContext();

	const { formStage: fiatFormStage } = useFiatWithdrawRequestContext();

	const { formStage: usdFormStage } = useUsdWithdrawRequestContext();

	const { data: featureNotesData } = useGetFeatureNoteQuery(undefined, alwaysRefetchApiQueryOptions);

	const featureNotes = featureNotesData?.data;

	const noteData = featureNotes?.find(({ feature, type }) => feature === 'wallet' && type === 'notes');

	const isUsd = selectedWallet?.currency === 'USD';

	const activeStage = isUsd ? usdFormStage.stage : fiatFormStage.stage;

	const showHeader = activeStage === 'withdraw-funds';

	return (
		<>
			{showHeader && (
				<>
					<div className='payment-request-form_notificationbanner'>
						<NotificationBanner
							message={noteData?.message}
							status='warning'
							type='standard'
						/>
					</div>

					<SelectWallet
						title='Where do you want to withdraw from?'
						selectWallet={selectWallet}
						selectedWallet={selectedWallet}
						type='withdraw'
					/>
				</>
			)}
		</>
	);
};

export default Header;
